export function mapEntityProperties<T extends object>(
  target: T,
  source: Partial<Record<keyof T, unknown>>,
  options?: {
    exclude?: Array<keyof T>
    map?: Partial<Record<keyof T, unknown>>
  }
) {
  const newTarget = target
  for (const key in newTarget) {
    if (options?.exclude?.includes(key)) {
      delete newTarget[key]
      continue
    }

    if (Object.prototype.hasOwnProperty.call(source, key)) {
      newTarget[key] = source[key] as T[typeof key]
    }
  }

  if (options?.map) {
    for (const key in options.map) {
      newTarget[key] = options.map[key] as T[typeof key]
    }
  }
}
